module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1134.c341f5bf.jpg";